import { FormLabelProps, FormLabel as MuiFormLabel } from "@mui/material";

type Props = FormLabelProps;

export const FormLabel = ({ children, ...props }: Props) => {
  return <MuiFormLabel {...props}>{children} </MuiFormLabel>;
};
